<iframe title="treemap" src="/map.html" class="w-full h-screen"></iframe>